module.exports = __webpack_public_path__ + "static/media/4.38c6d3e4.png";